module.exports = __webpack_public_path__ + "img/质量稽核select.52ae1613.svg";